import { AlertBar } from '@civilgrid/ui/components';
import { useExportLabels } from '~/hooks/useExportTerminologyEnabled';

/** Shown on the export tab, in place of the form, to roles without `DownloadData`. */
export default function NoDownloadPermissionNotice() {
  const labels = useExportLabels();
  return (
    <div data-testid="exports-no-permission">
      <AlertBar variant="warning" icon="warning" title={labels.noPermission} />
    </div>
  );
}
